import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 94DAFCB6-FA70-4DAE-B3DF-A107031F81E8
 * name currency-try
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-try.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyTryIcon = createSvgIcon(<><path d="M9 8.76V3H11V7.5L15 5V7.36L11 9.87L11 12.22L15 9.72V12.08L11 14.59V19C13.76 19 16 16.76 16 14H18C18 17.87 14.87 21 11 21H9V15.84L6 17.72V15.36L9 13.5V11.12L6 13V10.64L9 8.76Z" /></>, 'CurrencyTryIcon');
export default CurrencyTryIcon